module.exports = __webpack_public_path__ + "static/media/phone-call-fill.6c9836a5.svg";